import { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { fileUrl, apiError } from "@/lib/api";

// Uploads files to object storage and returns their /api/files/... path via onChange.
export function ImageUploader({ value = [], onChange, accept = "image/*", multiple = true, label = "上传图片 / Upload" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const list = Array.isArray(value) ? value : value ? [value] : [];

  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const paths = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        paths.push(data.url);
      }
      onChange(multiple ? [...list, ...paths] : paths[0]);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (idx) => {
    if (multiple) onChange(list.filter((_, i) => i !== idx));
    else onChange("");
  };

  const isVideo = accept.includes("video");

  return (
    <div>
      <div className="flex flex-wrap gap-3">
        {list.map((p, i) => (
          <div key={i} className="relative w-24 h-24 rounded-lg overflow-hidden fk-border">
            {isVideo ? <video src={fileUrl(p)} className="w-full h-full object-cover" /> : <img src={fileUrl(p)} alt="" className="w-full h-full object-cover" />}
            <button type="button" onClick={() => remove(i)} className="absolute top-0.5 right-0.5 bg-black text-white rounded-full p-0.5"><X size={14} /></button>
          </div>
        ))}
        <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} data-testid="uploader-btn" className="w-24 h-24 rounded-lg fk-border border-dashed flex flex-col items-center justify-center gap-1 text-xs bg-white fk-lift">
          {busy ? <Loader2 className="animate-spin" size={18} /> : <Upload size={18} />}
          <span>{label}</span>
        </button>
      </div>
      <input ref={inputRef} type="file" accept={accept} multiple={multiple} onChange={handle} className="hidden" />
    </div>
  );
}
